import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutRoutingModule } from './about-routing.module';
import { StaticPageFooterModule } from 'src/app/shared/static-page-footer/static-page-footer.module';
import { AboutComponent } from 'src/app/pages/about/about.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { HtmlFormatPipeModule } from 'src/app/pipes/html-format-pipe.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    AboutComponent,
  ],
  imports: [
    CommonModule,
    AboutRoutingModule,
    StaticPageFooterModule,
    HtmlFormatPipeModule,
    TranslateModule,
    RouterModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    AboutComponent
  ]
})
export class AboutModule { }
